let hasRenderedInitialRoute = false

export function markInitialRouteRendered() {
  hasRenderedInitialRoute = true
}

export function hasInitialRouteRendered() {
  return hasRenderedInitialRoute
}
